module.exports = __webpack_public_path__ + "img/Presentation10.f4d2cbd4.png";